// See: https://stackoverflow.com/questions/951021/what-is-the-javascript-version-of-sleep

export async function sleep(ms: number): Promise<void> {
  return new Promise<void>((resolve) => setTimeout(resolve, ms));
}
